import React from "react";
import DownloadIcon from "../../../../styles/images/download-icon.png";
import ExportToExcelWithApi from "../../common/ExportToExcelWithApi";

function UiDbSliderCard(props) {
     const {
          title,
          amount,
          columnOneAmount,
          columnOne,
          columnTwoAmount,
          columnFourAmount,
          columnFour,
          columnTwo,
          columnThreeAmount,
          columnThree,
          columnFiveAmount,
          columnFive,
          columnSixAmount,
          columnSix,
          exportInfo,
     } = props;
     return (
          <>
               <div className="sba-db-card-wr">
                    <div className="sba-db-card-wr__top">
                         <h4>{title}</h4>
                         <span className='sba-card-download-icon'>
                              {
                                   (exportInfo!=null)?  <ExportToExcelWithApi 
                                   name={exportInfo.name}
                                   data={exportInfo.data}
                                   onDownloadClick={(onDownloadComplete) => {
                                        if (exportInfo.fetchDataForExport) {
                                             exportInfo.fetchDataForExport(onDownloadComplete);
                                         }
                                   }}
                              /> : ''
                              }
                        
                         </span>
                    </div>
                    {title === "Custom Rewards Issued" ? (
                         <div className="sba-db-card-wr__amount">
                              <h2>{amount}</h2>
                         </div>
                    ) : (
                         <div className="sba-db-card-wr__campaign-titles">
                              <div className="sba-db-card-wr__campaign-box">
                                   <h3>{columnOneAmount}</h3>
                                   <label>{columnOne}</label>
                              </div>
                              <div className="sba-db-card-wr__campaign-box">
                                   <h3>{columnTwoAmount}</h3>
                                   <label>{columnTwo}</label>
                              </div>
                              {props.columnThree && (
                                   <div className="sba-db-card-wr__campaign-box">
                                        <h3>{columnThreeAmount}</h3>
                                        <label>{columnThree}</label>
                                   </div>
                              )}

                              {props.columnFour && (
                                   <div className="sba-db-card-wr__campaign-box">
                                        <h3>{columnFourAmount}</h3>
                                        <label>{columnFour}</label>
                                   </div>
                              )}

                              {props.columnFive && (
                                   <div className="sba-db-card-wr__campaign-box">
                                        <h3>{columnFiveAmount}</h3>
                                        <label>{columnFive}</label>
                                   </div>
                              )}

                              {props.columnSix && (
                                   <div className="sba-db-card-wr__campaign-box">
                                        <h3>{columnSixAmount}</h3>
                                        <label>{columnSix}</label>
                                   </div>
                              )}
                         </div>
                    )}
               </div>
          </>
     );
}

export default UiDbSliderCard;
